

/**
 * @classdesc GIA
 * @kind class
 * @export
 * @prop {boolean} propose - Propose la GIA
 * @prop {boolean} selected - Selectionne la GIA
 * @prop {int} prix - Prix de la GIA
 * @class GIA
 */
export default class GIA {
    id_module;
    propose = false;
    selected = false;
    prix = 0;

    /**
     * Creates an instance of GIA.
     * @constructs
     * @kind function
     * @memberof GIA
     */
    constructor(id_module) {
        this.id_module = id_module;
    }

    set(data) {
        if (!data) return;
        for (const [key, value] of Object.entries(data)) {
            if (this.hasOwnProperty(key)) {
                this[key] = value;
            }
        }
    }
    set_propose(propose) {
        this.propose = propose == "1";
    }

    set_prix(prix) {
        let rate = 20;
        if (this.id_module == 340 || this.id_module == 337) {
            rate = 26;
        }
        if (prix < 10) {
            this.propose = false;
        }
        let res = (parseFloat(prix) * rate) / 100;
        this.prix = res;
        this.update_cart();
    }

    update_cart() {
        let cart = { prix: 0, nb_articles: 0 };
        if (this.selected && this.propose) {
            cart.prix = this.prix;
            cart.nb_articles = 1;
        }
        this.cart = cart;
        return cart;



    }

    getSimplifiedData() {
        if (!this.propose || !this.selected) return null;
        let infos = {
            prix: this?.cart?.prix,
        }
        return infos;
    }




}